
import {Component, Mixins, Prop} from "vue-property-decorator";
import {Bar, mixins} from 'vue-chartjs'

@Component({
    name: "BarChart",
    extends: Bar,
    mixins: [mixins.reactiveProp]
})
export default class extends Mixins(mixins.reactiveProp, Bar) {
    @Prop({ required: true }) chartData!: any;
    @Prop({ required: true }) options!: any;
    mounted () {
        // Overwriting base render method with actual data.
        this.renderChart(this.chartData, this.options);
    }
}
